import axios from "axios";
const BASE_URL = `/api`

export const useRazorpayPayment = () => {
  const loadScript = () => {
    return new Promise((resolve) => {
      // Check if already loaded
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const pay = async ({ 
    amount, 
    orderId, // Pass order ID for reference
    customerName,
    customerEmail,
    customerPhone,
    onSuccess, 
    onError 
  }) => {
    const res = await loadScript();

    if (!res) {
      onError?.("Razorpay SDK failed to load");
      return;
    }

    try {
      // 1. Create order from backend (amount in rupees, backend converts to paise)
      const { data: order } = await axios.post(
        `${BASE_URL}/payment/create-order`,
        { 
          amount: amount,
          order_id: orderId // Pass your internal order ID for reference
        }
      );

      // 2. Open Razorpay checkout
      const options = {
        key: order.key_id, // Get key from backend for security
        amount: order.amount,
        currency: order.currency,
        order_id: order.razorpay_order_id,
        name: "Plant Nursery",
        description: `Order Payment - ${orderId}`,
        image: "", // Add your logo URL if needed
        handler: async function (response) {
          try {
            // 3. Verify payment
            const verifyRes = await axios.post(
              `${BASE_URL}/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                order_id: orderId // Your internal order ID
              }
            );

            if (verifyRes.data.success) {
              // Pass payment details along with success
              onSuccess?.({
                ...response,
                payment_id: response.razorpay_payment_id,
                verified: true
              });
            } else {
              onError?.("Payment verification failed");
            }
          } catch (err) {
            onError?.(err.response?.data?.error || err.message);
          }
        },

        prefill: {
          name: customerName || "Customer",
          email: customerEmail || "customer@example.com",
          contact: customerPhone || "9999999999",
        },

        notes: {
          internal_order_id: orderId
        },

        theme: {
          color: "#2e7d32", // Green to match your theme
        },

        // Handle payment failure
        modal: {
          ondismiss: function () {
            onError?.("Payment cancelled by user");
          }
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (response) {
        onError?.(`Payment failed: ${response.error.description}`);
      });
      rzp.open();
    } catch (err) {
      onError?.(err.response?.data?.error || err.message);
    }
  };

  return { pay };
};